import { createRequest } from './createRequest'

export const internshipGetPath = '/internship/get'
export const internshipGet = createRequest({ path: internshipGetPath })

export const internshipCreatePath = '/internship/create'
export const internshipCreate = createRequest({ path: internshipCreatePath })

export const internshipEditPath = '/internship/edit'
export const internshipEdit = createRequest({ path: internshipEditPath })

export const internshipTraineesPath = '/internship/trainees'
export const internshipTrainees = createRequest({ path: internshipTraineesPath })


export const internshipListPath = '/internship/list'
export const internshipList = createRequest({ path: internshipListPath })

export const internshipDeletePath = '/internship/delete'
export const internshipDelete = createRequest({ path: internshipDeletePath })
